<template>
  <div class="filterConditionContainer">
    <el-card class="box-card">
      <div class="filterCondition" >
        <div class="searchIcon">
          <i class="el-icon-search"></i>
        </div>
        <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
          <el-form-item :label="$t('filters.time')" v-if="isEmpty(filterForm.dateMonth)">
            <el-date-picker
              style="width: 100%"
              v-model="filterForm.dateMonth"
              type="month"
              :placeholder="$t('filters.chooseMonth')"
              format="yyyy-MM"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <customDate
            v-if="isEmpty(filterForm.date)"
            v-model="filterForm.date"
            ref='CustomDate'
          />
          <el-form-item v-if="isEmpty(filterForm.compareType)" style="text-align: center">
            <el-radio-group v-model="filterForm.compareType" style="text-align: center">
              <el-radio-button label="none">{{ $t('filters.dangqian') }}</el-radio-button>
              <el-radio-button label="tongbi" v-if="filterForm.date.dateType !== 'day' && filterForm.date.dateType !== 'year'">{{ $t('filters.tongbi') }}</el-radio-button>
              <el-radio-button label="huanbi" v-if="filterForm.date.dateType !== 'day'">{{ $t('filters.huanbi') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('filters.column')" v-if="isEmpty(filterForm.column)">
            <el-select v-model="filterForm.column" :placeholder="$t('filters.chooseColumn')" @change="change">
              <el-option
                v-for="item in columnOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.locate')" v-if="isEmpty(filterForm.locateOf)">
            <el-select v-model="filterForm.locateOf" multiple :placeholder="$t('filters.chooseLocate')" @change="change">
              <el-option
                v-for="item in locateOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.region')" v-if="isEmpty(filterForm.regionNo)">
            <el-select v-model="filterForm.regionNo" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
              <el-option
                v-for="item in regionOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.province')" v-if="isEmpty(filterForm.provinceNo)">
            <el-select v-model="filterForm.provinceNo" multiple :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()">
              <el-option
                v-for="item in provinceOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.city')" v-if="isEmpty(filterForm.cityNo)">
            <el-select v-model="filterForm.cityNo" multiple :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()">
              <el-option
                v-for="item in cityOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Cluster Name" v-if="isEmpty(filterForm.clusterName)">
            <el-select v-model="filterForm.clusterName" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
              <el-option
                v-for="item in clusterNameOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Concept" v-if="isEmpty(filterForm.concept)">
            <el-select v-model="filterForm.concept" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
              <el-option
                v-for="item in conceptOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="City Tier" v-if="isEmpty(filterForm.clusterGroup)">
            <el-select v-model="filterForm.clusterGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
              <el-option
                v-for="item in cityTierOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Tz Group" v-if="isEmpty(filterForm.tzGroup)">
            <el-select v-model="filterForm.tzGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
              <el-option
                v-for="item in tzGroupOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Format" v-if="isEmpty(filterForm.format)">
            <el-select v-model="filterForm.format" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
              <el-option
                v-for="item in formatOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.reseller')" v-if="isEmpty(filterForm.resellerNo)">
            <el-select v-model="filterForm.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
              <el-option
                v-for="item in resellerOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.subReseller')" v-if="isEmpty(filterForm.subReseller)">
            <el-select v-model="filterForm.subReseller" multiple :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()">
              <el-option
                v-for="item in subResellerOptions"
                :key="item.itemKey"
                :label="item.itemValue"
                :value="item.itemKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="HubDoor" v-if="isEmpty(filterForm.hubDoor)">
            <el-select v-model="filterForm.hubDoor" clearable :placeholder="$t('choose')" @change="resetFilters()">
              <el-option
              v-for="item in hubDoorOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.gender')" v-if="isEmpty(filterForm.gender)">
            <el-select v-model="filterForm.gender" multiple :placeholder="$t('filters.chooseGender')" @change="change">
              <el-option
                v-for="item in genderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.age')" v-if="isEmpty(filterForm.age)">
            <el-select v-model="filterForm.age" multiple :placeholder="$t('filters.chooseAge')" @change="change">
              <el-option
                v-for="item in ageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('filters.buyWill')" v-if="isEmpty(filterForm.willingToBuy)">
            <el-select v-model="filterForm.willingToBuy" multiple :placeholder="$t('filters.chooseBuyWill')" @change="change">
              <el-option
                v-for="item in isBuyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <pickTryon v-if="isEmpty(filterForm.tryOn)"
            v-model="filterForm.tryOn"
          />
          <el-form-item :label="$t('filters.doorName')" v-if="isEmpty(filterForm.door)" >
            <span @click="onChooseDoor">
              <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
            </span>
          </el-form-item>
          <el-form-item label="门店编号" v-if="isEmpty(filterForm.posId)">
            <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')" @change="change"></el-input>
          </el-form-item>
        </el-form>
        <slot></slot>
      </div>
    </el-card>
    <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
import PickDoor from './pickDoor'
import CustomDate from './customDate'
import PickTryon from './pickTryon'
import {genderOptions, isBuyOptions, ageOptions} from '@/utils/global'

export default {
  name: 'FilterCommon',
  components: {
    pickDoor: PickDoor,
    customDate: CustomDate,
    pickTryon: PickTryon
  },
  props: {
    value: Object
  },
  computed: {
    isBuyOptions () {
      const lang = Cookies.get('language') || 'zh_CN';
      return isBuyOptions[lang]
    },
    ageOptions (){
      const lang = Cookies.get('language') || 'zh_CN';
      return ageOptions[lang]
    }
  },
  mounted () {
    if (!this.isEmpty(this.filterForm.column)) {
      this.getColumnOptions()
    }
    this.getRangeList()
    this.getDoorList()
  },
  data: function () {
    return {
      filterForm: this.value,
      regionOptions: [
      ],
      provinceOptions: [
      ],
      cityOptions: [
      ],
      clusterNameOptions: [
      ],
      conceptOptions: [
      ],
      cityTierOptions: [
      ],
      tzGroupOptions: [
      ],
      formatOptions: [
      ],
      resellerOptions: [
      ],
      subResellerOptions:[
      ],
      locateOptions: [
      ],
      columnOptions: [],
      doorOptions: [],
      // tryOnOptions: tryOnOptions,
      genderOptions: genderOptions,
      // ageOptions: ageOptions,
      // isBuyOptions: isBuyOptions,
      hubDoorOptions: [],
      doorList: [], // 供筛选的门店列表
      searchKey: '', // 门店搜索关键字
      checkList: [] // 选中的门店
    }
  },
  methods: {
    change: function () {
      console.log('同步更新')
      console.log('this.filterForm', this.filterForm)
      this.$emit('input', this.filterForm)
    },
    resetFilters: function () {
      this.getRangeList()
      this.change()
    },
    isEmpty: function (data) {
      return !_.isNil(data)
    },
    getDoorList: async function () {
      this.checkList = []
      let res = await this.$api.survey_api.listDoor({ doorName: this.searchKey, size: 1000 })
      if (res) {
        this.doorList = res.list
      } else {
      }
    },
    getColumnOptions: async function () {
      let res = await this.$api.survey_api.conditionQuestion();
      const columns = res.columns
      this.columnOptions = _.map(columns, (item) => ({label: item.itemValue, value: item.itemKey}))
    },
    clearDate: function () {
      if(this.$refs.CustomDate){
        this.$refs.CustomDate.clearDate()
      }
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.filterForm.cityNo,
        'clusterGroup': this.filterForm.clusterGroup,
        'clusterName': this.filterForm.clusterName,
        'concept': this.filterForm.concept,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'format': this.filterForm.format,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
        'tzGroup': this.filterForm.tzGroup,
        'hubDoor': this.filterForm.hubDoor
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await this.$api.survey_api.conditionCommon(submitParams)
      this.locateOptions = res.locateList
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.cityTierOptions = res.clusterGroupList
      this.clusterNameOptions = res.clusterNameList
      this.conceptOptions = res.conceptList
      this.formatOptions = res.formatList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
      this.tzGroupOptions = res.tzGroupList
      this.hubDoorOptions = res.hubDoorList
    },
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.filterForm = val
    }
  }
}
</script>

<style lang="scss">
.filterConditionContainer{
  .doorList{
    height: 360px;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilterCommon.vue